import React from 'react';
import { tw } from 'twind';

import { ActiveCartItem } from 'types/cart';
import { CartItem } from '__generated__/graphql';
import { useFeature } from 'hooks/useFeature';

export const CartAppliedProductPromotions: React.FC<{
  product: ActiveCartItem | CartItem;
  className?: string;
}> = ({ product, className }) => {
  const displayPromoAppliedPromotion = useFeature(
    'DISPLAY_PROMO_APPLIED_PROMOTION'
  );

  if (
    !displayPromoAppliedPromotion ||
    product?.__typename !== 'ProductCartItem' ||
    !product?.adjustments?.length
  ) {
    return null;
  }

  return (
    <ul className={tw('uppercase text-puma-red text-xs', className)}>
      {product.adjustments.map(x => (
        <li key={x.promotionId}>{x.promotion?.calloutMessage}</li>
      ))}
    </ul>
  );
};
